import { NgModule } from '@angular/core';

import { NameWithoutPipesPipe } from '../../core/pipes/filters/name-without-pipes.pipe';
import { CallBackPipe } from './call-back/call-back.pipe';
import { DateAgoPipe } from './dateAgo/date-ago.pipe';
import { EventMorePipe } from './event-more/event-more.pipe';
import { EventNamePipe } from './event-name/event-name.pipe';
import { NumToThousandsPipe } from './num-to-thousands/num-to-thousands.pipe';
import { NumberNormalizerPipe } from './number-normalizer/number-normalizer.pipe';
import { OddsFormatPipe } from './odds-format/odds-format.pipe';
import { SafePipe } from './safe/safe.pipe';

@NgModule({
    imports: [
        NumberNormalizerPipe,
        EventNamePipe,
        SafePipe,
        OddsFormatPipe,
        EventMorePipe,
        CallBackPipe,
        NumToThousandsPipe,
        DateAgoPipe,
        NameWithoutPipesPipe,
    ],
    providers: [EventNamePipe, OddsFormatPipe],
    exports: [
        NumberNormalizerPipe,
        SafePipe,
        EventNamePipe,
        OddsFormatPipe,
        EventMorePipe,
        CallBackPipe,
        NameWithoutPipesPipe,
        DateAgoPipe,
        NumToThousandsPipe,
    ],
})
export class SharedPipesModule {}
